import { useEffect, useState } from 'react';
import { getPrivacyPolicy } from '../api/publicApi';
import { SkeletonBox } from '../components/Skeleton';
import { cleanHtmlContent } from '../utils/htmlUtils';

export default function PrivacyPolicyPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getPrivacyPolicy()
      .then(res => {
        if (cancelled) return;
        setData(res.data?.data || res.data);
        setLoading(false);
      })
      .catch(err => {
        if (cancelled) return;
        setError(err.message || 'Erreur lors du chargement');
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="main-col pt-3" style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px' }}>
        <SkeletonBox width="60%" height={32} style={{ marginBottom: 16 }} borderRadius={4} />
        <SkeletonBox width="30%" height={14} style={{ marginBottom: 24 }} borderRadius={4} />
        <SkeletonBox height={200} style={{ marginBottom: 16 }} borderRadius={4} />
        <SkeletonBox height={150} style={{ marginBottom: 16 }} borderRadius={4} />
        <SkeletonBox height={180} borderRadius={4} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-col pt-3" style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px', textAlign: 'center' }}>
        <h2 style={{ color: '#e00', marginBottom: 12 }}>Erreur</h2>
        <p style={{ color: '#888' }}>{error}</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="main-col pt-3" style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px', textAlign: 'center' }}>
        <p style={{ color: '#888' }}>Aucune politique de confidentialité disponible.</p>
      </div>
    );
  }

  // If body_html is provided, render it with inline styles from head_html
  if (data.body_html) {
    // Extract style tag from head_html
    const styleMatch = data.head_html?.match(/<style>([\s\S]*?)<\/style>/);
    const styles = styleMatch ? styleMatch[1] : '';

    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: styles }} />
        <div
          className="main-col pt-3"
          dangerouslySetInnerHTML={{ __html: data.body_html }}
        />
      </>
    );
  }

  // Fallback for old API format with html_content
  if (data.html_content) {
    return (
      <iframe
        srcDoc={data.html_content}
        title={data.title || 'Politique de Confidentialité'}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
          display: 'block',
        }}
      />
    );
  }

  // Fallback for structured data
  return (
    <div className="main-col pt-3" style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px' }}>
      {data.title && (
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8, color: '#1a1a2e' }}>
          {data.title}
        </h1>
      )}
      <div
        className="page-content"
        style={{ lineHeight: 1.8, color: '#333' }}
        dangerouslySetInnerHTML={{ __html: cleanHtmlContent(data.contenu || '') }}
      />
    </div>
  );
}
